//eslint-disable import/first

import React from 'react';
import ProjectItem from './ProjectItem';

import { FixedSizeList as List } from 'react-window';


class ProjectList extends React.Component {
  
  render() {

    return (
      <ul id="consultants-list" className="list" style={{height:"200px"}}>
        <List
          height={window.innerHeight - 180}
          itemCount={this.props.items.length}
          itemSize={32}
          width="100%"
        >
        {({ index , style }) => (
          <div style={style}>
            <ProjectItem
              key={this.props.items[index]._id}
              id={this.props.items[index]._id}
              value={this.props.items[index].content.information.name}
              docId={this.props.docId}
              index={index}
              permission={this.props.permission}
            />
          </div>
        )}
        </List>
      </ul>
    );
  }
}

export default ProjectList;